<template>
  <v-data-table :headers="headers" :items="dataRows" disable-pagination>
    <template v-slot:item.timestamp="{ item }">
      {{ item.timestamp ? $d(new Date(item.timestamp), "datetime") : "" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <va-action-button icon="mdi-attachment" label="Request" text @click="showAttachment(item, 'request')" :disabled="item.request == null"></va-action-button>
      <va-action-button icon="mdi-attachment" label="Response" text @click="showAttachment(item, 'response')" :disabled="item.response == null"></va-action-button>
      <va-action-button icon="mdi-attachment" label="Exception" text @click="showAttachment(item, 'exception')" :disabled="item.exception == null"></va-action-button>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: ["item"],
  async created() {
    const response = await this.$admin.http.get(`${process.env.VUE_APP_API_URL}/messages?channel=${this.item.channel.code}&references[order_id]=${this.item.id}`);
    this.dataRows = response.data.data;
  },
  methods: {
    showAttachment(item, type) {
      window.open(`${process.env.VUE_APP_API_URL}/messages/${item.id}/${type}`, "_blank");
    },
  },
  data() {
    return {
      dataRows: [],
      headers: [
        {
          text: "Timestamp",
          value: "timestamp",
          type: "date"
        },
        {
          text: "Content-Type",
          value: "content_type"
        },
        {
          text: "Sender",
          value: "sender"
        },
        {
          text: "Recipient",
          value: "recipient"
        },
        {
          value: "actions",
          sortable: false
        }
      ]
    };
  }
};
</script>
